import SizeCrustStepDesktop from './SizeCrustStepDesktop';

export default SizeCrustStepDesktop;
